import { languageIdBus } from "@/event/languageIdBus"
import type { SelectedOptionHappy, SelectedOptionValueHappy } from "@/happyTheme/interfaces/product/selectedOptionInterface"
import type { Option } from "@/storage/products"
import { getOptionName } from "@/utils/product/getOptionName"

export function getEmptySelectedValuesHappy(option: Option): SelectedOptionHappy {
    const resetOption =
        option?.values.filter((o) => o.reset == 1).map((o) => o.option_value_id) || []

    const quantityPaid =
        option.free_option_count !== 0 && option.max_option_count === 0
            ? option.values.length - resetOption.length - option.free_option_count
            : (option.max_option_count ?? 0) - (option.free_option_count || 0)

    const emptyValues: SelectedOptionValueHappy = {
        radio_option: {
            option_value_id: 0,
            option_value_name: '',
            option_value_image: '',
            option_value_price: '0'
        },
        checkbox_option: {
            option_value_free: [],
            quantity_free: option.free_option_count || 0,
            option_value_paid: [],
            quantity_paid: quantityPaid
        }
    }

    return {
        option_id: option.option_id,
        name_option: getOptionName(option, languageIdBus.value),
        required: option.required,
        selected_values: emptyValues
    }
}